import React from 'react';
import { AsperaTableData } from '../../classes/AsperaTableData';
/**
 * React Component
 *
 * The AsperaDataTableSkeleton provides the custom data table skeleton that follows width and overflow/bulk usage
 *
 * @example
 * ```javascript
 * <AsperaDataTableSkeleton hasBatchActions={true} hasOverflow{false} columnData={columnData} />
 * ```
 */
class AsperaDataTableSkeleton extends React.Component {
    getColumns() {
        const { hasBatchActions, columnData, hasOverflow, tableId, genericTable } = this.props;
        const columns = [];
        if (hasBatchActions) {
            columns.push({ width: 44, hasHeader: true, importance: 'primary' });
        }
        columnData.forEach(column => {
            let width;
            if (column.type === 'icon' || column.type === 'image') {
                width = 48;
            }
            else {
                width = column.width;
            }
            const tableData = new AsperaTableData(tableId, genericTable);
            const overrideWidth = tableData.getTableSizing(column.key);
            if (overrideWidth) {
                width = overrideWidth;
            }
            columns.push({ width, hasHeader: !!column.name, importance: column.importance || 'primary' });
        });
        if (hasOverflow) {
            columns.push({ width: 64, hasHeader: false, importance: 'primary' });
        }
        return columns;
    }
    render() {
        const { className, rowCount } = this.props;
        const columns = this.getColumns();
        const rows = [];
        for (let i = 0; i < (rowCount || 10); i++) {
            rows.push(i);
        }
        return (React.createElement("div", { className: `aspera-data-table-skeleton ${className ? className : ''}`, "data-auto": "table-skeleton" },
            React.createElement("table", { className: "cds--skeleton cds--data-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null, columns.map((column, index) => {
                        const style = column.width ? { width: `${column.width}px` } : undefined;
                        return React.createElement("th", { key: index, style: style, className: `aspera-cell-importance-${column.importance}` }, column.hasHeader && React.createElement("span", { className: "skeleton-animation" }));
                    }))),
                React.createElement("tbody", null, rows.map(row => {
                    return React.createElement("tr", { key: row }, columns.map((column, index) => {
                        return React.createElement("td", { key: index, className: `aspera-cell-importance-${column.importance}` },
                            React.createElement("span", { className: "skeleton-animation" }));
                    }));
                })))));
    }
}
export default AsperaDataTableSkeleton;
